export const SHOPGOODWILL_CHANNEL_ID = 1
export const EBAY_CHANNEL_ID = 2

export type ListingType = 'AUCTION' | 'FIXED_PRICE'

export type PreservedListingOptions = {
  noCombineShipping?: boolean
  itemFeatured?: boolean
}

export type SgwForm = {
  listingType?: ListingType
  price?: string // Don't think about auction vs fixed price. Just think of this as "price".
  buyItNowPrice?: string
  shippingPrice?: string
  carrierId?: number
  bidIncrement?: string
  reservePrice?: string
  handlingPrice?: string
  categoryMarketCategoryId?: number
  auctionDuration?: string
  noCombineShipping?: boolean
  itemFeatured?: boolean
}

export type EbayForm = {
  startingPrice?: string
  buyItNowPrice?: string
  listingType?: string
  listingDuration?: string
  quantity?: number
  condition?: number
  categoryMarketCategoryId?: number
  categoryMarketCategory?: {
    id: number
    pathCache: string
    marketId: number
    isLeaf?: boolean
  } | null
  shippingProfileId?: number
  returnProfileId?: number
  paymentProfileId?: number
  dispatchTimeMax?: number
  marketAccountId?: number
  specifics: Record<string, string>
  productListingDetails: Record<string, string>
  conditionDescriptors?: Record<string, string>
  isConcurrent?: boolean
  oldCategoryConfig?: Partial<EbayForm>
}
